'use client';

import { useEntrySearchStore } from '@liquorice/next-search';
import Grid from '../ui/Grid';
import SearchResult from './SearchResult';

export default function SearchResults() {
  const { results } = useEntrySearchStore((s) => s);

  return (
    <Grid cx={{ rowGap: 'xl' }}>
      {results.map((result) => (
        <Grid.Col key={result.id} md={6} lg={4}>
          {/* @ts-expect-error - this is not typed but still a valid prop  */}
          <SearchResult id={result.id} typeName={result.__typename} />
        </Grid.Col>
      ))}
    </Grid>
  );
}
